import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import Title from 'pages/Words/PageFlip/Title'
import Cover from 'pages/Words/PageFlip/Cover'
import Page from "pages/Words/PageFlip/Page";
import HTMLFlipBook from "react-pageflip";
import { isEmpty } from "lodash";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { BackAndNextButtons, WrapPageFlip } from './Style'
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { Comment } from "components/Form";
import { IconButton, SvgIcon } from "@mui/material";
import { WordsContext } from "../Words";
import './PageFlipSass.scss'
import { AnimatePresence, motion } from 'framer-motion';
import { NextButton } from "pages/School/PerformAssessment";
import { useLocation } from "react-router-dom";

const CustomBook = (props) => {
    const { pages, title, comment, visibleType } = props
    const { hideDisabledNext, finishPerfom, showCartoon, handleNext } = useContext(WordsContext)
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const useMouseEvents = pathSegments[0] != "perform-assessments"
    const hideNextButton = useMouseEvents

    const flipBook = useRef()
    const book = useRef()

    const pageCount = book?.current?.pageFlip()?.getPageCount()
    const currentPageIndex = book?.current?.pageFlip()?.getCurrentPageIndex()

    const [currentPage, setCurrentPage] = useState(pages?.length + 1)
    const [isOpen, setIsOpen] = useState(true);
    const [initialFlag, setInitialFlag] = useState(true);
    const [disabledNext, setDisabledNext] = useState(true)

    const onFlip = useCallback((e) => {
        setIsOpen(prevState => !prevState);
        setCurrentPage(e.data)
        setInitialFlag(false)
        setDisabledNext(true)
    }, []);

    const handleFlipPrev = () => {
        if (handleNext)
            handleNext()
        else {
            if (currentPage > 0) {
                book.current.pageFlip().flipPrev();
            }
            else
                finishPerfom?.()
        }
    };

    useEffect(() => {
        if (disabledNext)
            setTimeout(() => {
                setDisabledNext(false)
            }, currentPage == pages?.length + 1 ? 1000 : 2000);
    }, [disabledNext, currentPage, pages])

    const closed = "closed"
    const open = "open"

    let filpingClass = ""
    if (currentPage == 0 && initialFlag)
        filpingClass = closed
    else if (currentPage == pages.length + 1) {
        filpingClass = closed
    }
    else if (currentPage == 0 && !initialFlag)
        filpingClass = open

    return (
        <WrapPageFlip
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.5 }}
            transition={{ duration: 0.7 }}
            disabled={showCartoon}>
            {!isEmpty(pages) &&
                <React.Fragment>
                    {(
                        !currentPage &&
                        comment) ?
                        <Comment right={420} title="לחצו על עמודי הספר בכדי לדפדף בין העמודים" open={true} placement={"right"}>
                            <button style={{ background: "transparent", border: "none" }}></button>
                        </Comment>
                        :
                        <></>}

                    {pages.length ?
                        <div className={`book-container ${filpingClass}`} style={{ width: "100%" }}>
                            <HTMLFlipBook
                                flippingTime={800}
                                startPage={pages.length + 1}
                                width={203}
                                height={123}
                                autoSize={true}
                                onFlip={onFlip}
                                showPageCorners={false}
                                useMouseEvents={useMouseEvents}
                                swipeDistance={false}
                                // clickEventForward={false}
                                // disableFlipByClick={true}
                                size="stretch"
                                minWidth={200}
                                maxWidth={732}
                                minHeight={120}
                                maxHeight={1020}
                                maxShadowOpacity={0.5}
                                showCover={true}
                                mobileScrollSupport={true}
                                onChangeOrientation={() => { }}
                                className="demo-book"
                                usePortrait
                                ref={book}
                            // ref={(el) => (flipBook.current = el)}
                            >
                                <Cover>
                                    {"סוֹף!"}
                                    {!hideNextButton &&
                                        <div className="wrap-go-prev-page">
                                            <div className="go-prev-page">
                                                <NextButton action={handleFlipPrev} />
                                            </div>
                                        </div>}
                                </Cover>

                                {pages?.map((page, index) =>
                                    <Page hideNextButton={hideNextButton} visibleType={visibleType} disabledNext={hideDisabledNext ? false : disabledNext} currentPage={currentPage} handleFlipPrev={handleFlipPrev} key={index} number={pages.length - index} firstPage={index == pages.length - 1} title={title}>
                                        {page.map((word) =>
                                            word
                                        )}
                                    </Page>
                                )}

                                <Cover firstPage currentPage={currentPage} handleFlipPrev={handleFlipPrev}>
                                    <Title>
                                        {title}
                                    </Title>
                                    {!hideNextButton &&
                                        <div className="wrap-go-prev-page">
                                            <div className="go-prev-page">
                                                <NextButton disabled={hideDisabledNext ? false : disabledNext} action={handleFlipPrev} />
                                            </div>
                                        </div>}
                                </Cover>
                            </HTMLFlipBook>
                        </div>
                        : null}

                </React.Fragment>
            }
        </WrapPageFlip >
    )
}

export default CustomBook
